import { getGlobalTheme } from '@atlaskit/tokens/get-global-theme';

import type { MakeBridgeContext } from '../types';

import type { TBridgeMethod } from './types';

type EnableThemingContext = MakeBridgeContext<'environment' | 'bridgeControls'>;

/**
 * Activates theming in the iframe. First sends `__theme_enable` via
 * `BridgeControls.enableTheming` to set `isThemingEnabled = true` in the
 * iframe-side bridge client (which gates theming stylesheet loading), then
 * pushes the current host theme via `BridgeControls.setTheme`.
 *
 * Called by the Forge app's `@forge/bridge` when the app opts in to platform
 * theming. `surfaceColor` is always `null` here — the initial surface colour is
 * sent during the bridge handshake. This path only handles theme-mode changes.
 */
export const enableTheming: TBridgeMethod<EnableThemingContext, void, void> = async ({
	environment,
	bridgeControls,
}) => {
	bridgeControls.enableTheming();
	const currentTheme = getGlobalTheme();
	bridgeControls.setTheme(currentTheme, null, environment);
};
